// < ----- NETWORK ----- > //

// Single unified API URL: all tenants use the same backend
// In production, the backend resolves tenant from the Host header
const getBaseUrl = hostName => {
  if (hostName === 'localhost' || hostName.startsWith('localhost:') || hostName.startsWith('127.0.0.1')) {
    return 'http://localhost:3000';
  }
  return 'https://api.ordo.menu';
};

export const weekDays = [
  { id: 1, name: 'M' },
  { id: 2, name: 'T' },
  { id: 3, name: 'W' },
  { id: 4, name: 'TH' },
  { id: 5, name: 'F' },
  { id: 6, name: 'S' },
  { id: 0, name: 'S' },
];

export const PRICE_REGEX = /^\d+(\.\d{0,2}){0,1}$/;

export const BASE_URL = getBaseUrl(window.location.host);

export const UNAUTHORIZED = 401;

// < ----- ENUM ----- > //
export const TOKEN = 'token';

// Tenant config is loaded dynamically from the backend at app boot
let _tenantConfig = null;

export const fetchTenantConfig = async () => {
  if (_tenantConfig) return _tenantConfig;
  try {
    const response = await fetch(`${BASE_URL}/tenant/config`, {
      headers: { Host: window.location.host },
    });
    if (response.ok) {
      _tenantConfig = await response.json();
    }
  } catch (err) {
    console.warn('Failed to fetch tenant config, using defaults:', err);
  }
  return _tenantConfig;
};

export const getTenantConfig = () => _tenantConfig;
